// frontend/src/livequiz/sound.js
let audioCtx = null;

function getCtx() {
    if (!audioCtx) {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioCtx.state === 'suspended') audioCtx.resume();
    return audioCtx;
}

function tone(ctx, freq, start, duration, { type = 'sine', volume = 0.18 } = {}) {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = type;
    osc.frequency.value = freq;
    // Soft attack + smooth decay (removes the harsh "broken" clicky edges)
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(volume, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
    osc.start(start);
    osc.stop(start + duration + 0.05);
}

// Gentle two-note "ding-dong" — new question
export function playQuestionSound() {
    try {
        const ctx = getCtx();
        const now = ctx.currentTime;
        tone(ctx, 523.25, now, 0.35, { type: 'triangle' });        // C5
        tone(ctx, 783.99, now + 0.12, 0.5, { type: 'triangle' });  // G5
    } catch (e) { /* audio unavailable */ }
}

// Happy rising major arpeggio — correct answer
export function playCorrectSound() {
    try {
        const ctx = getCtx();
        const now = ctx.currentTime;
        tone(ctx, 523.25, now, 0.18, { type: 'triangle' });          // C5
        tone(ctx, 659.25, now + 0.10, 0.18, { type: 'triangle' });   // E5
        tone(ctx, 783.99, now + 0.20, 0.18, { type: 'triangle' });   // G5
        tone(ctx, 1046.5, now + 0.30, 0.45, { type: 'triangle' });   // C6
    } catch (e) { /* audio unavailable */ }
}

// Soft descending "wah-wah" — wrong answer (sad but not punishing)
export function playWrongSound() {
    try {
        const ctx = getCtx();
        const now = ctx.currentTime;
        tone(ctx, 311.13, now, 0.3, { type: 'sine', volume: 0.15 });         // Eb4
        tone(ctx, 233.08, now + 0.22, 0.55, { type: 'sine', volume: 0.15 }); // Bb3
    } catch (e) { /* audio unavailable */ }
}

// Short percussive blip — someone buzzed
export function playBuzzSound() {
    try {
        const ctx = getCtx();
        const now = ctx.currentTime;
        tone(ctx, 880, now, 0.12, { type: 'square', volume: 0.08 });
    } catch (e) { /* audio unavailable */ }
}

// Urgent rising alert — it's YOUR turn to answer
export function playYourTurnSound() {
    try {
        const ctx = getCtx();
        const now = ctx.currentTime;
        tone(ctx, 587.33, now, 0.15, { type: 'triangle' });          // D5
        tone(ctx, 880.0, now + 0.13, 0.15, { type: 'triangle' });    // A5
        tone(ctx, 1174.66, now + 0.26, 0.3, { type: 'triangle' });   // D6
    } catch (e) { /* audio unavailable */ }
}